import { SpinnerIcon } from "../../assets/SpinnerIcon";
import "./styles.scss";

export const Spinner = () => {
  return (
    <div className="spinner">
      <SpinnerIcon />
    </div>
  );
};
